import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchOrdersRequest, fetchLimitOrdersRequest } from '../../../store/reducers/orderReducer';

export const useOrders = () => {
    const dispatch = useDispatch();
    const { orders, limitOrders, error, loading } = useSelector(state => state.orders);

    useEffect(() => {
        // Initial load
        dispatch(fetchOrdersRequest());
        dispatch(fetchLimitOrdersRequest());

        // Keep the Limits / Executed lists live: re-fetch every second so a
        // limit order that just converted into a market order drops off the
        // Limits list (and appears under Executed) without a manual refresh.
        const intervalId = setInterval(() => {
            dispatch(fetchOrdersRequest());
            dispatch(fetchLimitOrdersRequest());
        }, 1000);

        return () => clearInterval(intervalId);
    }, [dispatch]);

    return { orders, limitOrders, error, loading };
};